import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Box, Image, Text, useColorModeValue } from '@chakra-ui/react'

import { getBggGameCoverUrl } from '../Utils'

export default function SortableGameTile({ id, item }) {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id })

	const border = useColorModeValue('gray.200', 'whiteAlpha.300')
	const bg = useColorModeValue('white', 'bgg.800')
	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		zIndex: isDragging ? 2 : undefined,
		opacity: isDragging ? 0 : 1,
		boxShadow: isDragging ? 'none' : undefined,
		touchAction: 'manipulation',
	}

	const gameLike = item || { name: '', thumbnail: null, image: null }

	return (
		<Box
			ref={setNodeRef}
			style={style}
			{...attributes}
			{...listeners}
			borderWidth="1px"
			borderColor={border}
			rounded="lg"
			overflow="hidden"
			bg={bg}
			boxShadow="sm"
			w={{ base: '72px', sm: '88px' }}
			flexShrink={0}
			cursor="grab"
			_active={{ cursor: 'grabbing' }}
			role="group"
			aria-label={item?.name ? `Move ${item.name}` : 'Move game'}
		>
			<Image
				src={getBggGameCoverUrl(gameLike)}
				alt=""
				width="100%"
				height={{ base: '104px', sm: '126px' }}
				objectFit="cover"
				bg="gray.100"
				draggable={false}
				pointerEvents="none"
			/>
			<Text px={1} py={1} fontSize="10px" fontWeight="600" noOfLines={2} color="gray.700" _dark={{ color: 'gray.200' }}>
				{item?.name || ''}
			</Text>
		</Box>
	)
}
